import { React, useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import Invoices from "../BiltyForm/Bilty";
// import "./ShowChalan.css";
import { setChalanDetail } from "../../storeSlices/chalanSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Printbilty from "../BiltyForm/Printbilty";
import { setBiltyDetail } from "../../storeSlices/biltySlice";
// import { setlocalChalanDetail } from "../../storeSlices/localChalanSlice";
// import Printchallanrasid from "./PrintChalanRasid";
const style2 = {
  position: "absolute",
  height: "100%",
  overflow: "scroll",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
};
function ShowBilty({ bilty }) {
  const [open2, setOpen2] = useState(false);
  const [biltyData, setBiltyData] = useState(bilty);
  const handleUpdateBilty = (updatedBilty) => {
    setBiltyData(updatedBilty);
  };

  useEffect(() => {
    console.log("useEffect hasbeen called");
  }, [open2]);
  // function changeCss() {
  //   document.getElementById("biltyform").classList.toggle("c-form");
  //   document.getElementById("bilty-template").classList.toggle("jadu");
  // }
  const handleClose = () => {
    console.log("first");
    setOpen(false);
  };
  const handleClose2 = () => {
    setOpen2(false);
    console.log("open2  from handleclose: ", open2);
  };
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const editChallan = (props) => {
    console.log("editpage : ", props);
    dispatch(setBiltyDetail(props));
    setOpen(true);

    // navigate("/dashbaord/bilty");
  };
  const printBilty = (props) => {
    setOpen2(true);
    console.log("props : ", props);
  };

  return (
    <div className="ch-bx">
      <div className="chLeftInfo">
        <h2>Truck Number ⇝ {biltyData.truck_no}</h2>
        <h2>Consignor ⇝ {biltyData.consignor}</h2>
      </div>
      <div className="chRightBtns">
        <Button onClick={() => editChallan(bilty)}>Edit</Button>
        <Button onClick={() => printBilty(bilty)}>Print</Button>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style2}>
          <Invoices
            data={biltyData}
            isEdit={true}
            onUpdate={handleUpdateBilty}
          />
        </Box>
      </Modal>
      <Modal
        open={open2}
        onClose={handleClose2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style2}>
          {/* <Printchallanrasid chalan={challan} handleClose2={handleClose2} /> */}
          <Printbilty
            details={biltyData}
            handleClose2={handleClose2}
            changeCss={true}
          />
        </Box>
      </Modal>
    </div>
  );
}

export default ShowBilty;
